import React from 'react';

import './styles.css';

export default function TituloPagina(props){
  return(
  <h1 className="titulo-pagina">{props.titulo}</h1>
  )
}